import React from 'react';
import styled from 'styled-components';

interface ILogoProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  inverted?: boolean;
}
const Img = styled.img.attrs<ILogoProps>(({ inverted = false, theme }) => ({
  src: inverted ? theme.logo.inverted : theme.logo.normal
}))`
  margin-left: 2rem;
`;

export const Logo: React.FC<ILogoProps> = (props) => {
  return <Img {...props} />;
};
